import React from "react";
import { Tabs, PageHeader } from "antd";

import { Behavior } from "./behavior";
import { BehaviorType } from "./behaviorType";

const { TabPane } = Tabs;

export function BehaviorPage() {
    return (
        <>
            <PageHeader title="Lista comportamentos" />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Tipos de comportamento" key="1">
                    <BehaviorType />
                </TabPane>
                <TabPane tab="Comportamentos" key="2">
                    <Behavior />
                </TabPane>
            </Tabs>
        </>
    );
}
